/**
 * 计算时间相关方法
 */
class CalculationTime {
  constructor () {
    this.countDay = null //总天数
    this.weeks = ['日', '一', '二', '三', '四', '五', '六']
  }

  //1.获取相差天数
  getCountDay (startTime, endTime) {
    // console.log(11,startTime,endTime);

    startTime = startTime.split(' ')[0]
    startTime = startTime.replaceAll('/', '-')
    endTime = endTime.split(' ')[0]
    endTime = endTime.replaceAll('/', '-')
    let startDate = new Date(startTime)
    let endDate = new Date(endTime)
    let date = endDate - startDate
    this.countDay = date / (1000 * 60 * 60 * 24)
  }

  //2.获取开始结束的所有月天日星期
  getStartEndAllDays (startTime, endTime, dayList = []) {
    // console.log(22,startTime,endTime);
    let startEndAlldayList = []
    this.getCountDay(startTime, endTime)
    let startDate = new Date(startTime)
    for (let i = 0; i <= this.countDay; i++) {
      let dateArr = []
      let obj = {
        date: '',
        week: '',
        m: null,
        status: 0
      }
      let currentDate = new Date(startDate)
      let y = currentDate.getFullYear()
      let m = (currentDate.getMonth() + 1) < 10 ? '0' + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1
      let d = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate()
      let w = this.weeks[currentDate.getDay()]
      startDate.setDate(startDate.getDate() + 1)
      dateArr.push(y, m, d)
      obj.date = dateArr.join('-')
      if (d == '01'||i==0) {
        obj.m = m
      }
      obj.d = d
      obj.week = w
      let arr = dayList.filter(item => {
        return item.day === obj.date
      })
      
      if (arr.length > 0) {
        
        obj.status = arr[0].status
      }
      startEndAlldayList.push(obj)
    }
    
    return startEndAlldayList
  }
  getMonthDays (arrList, dayList = []) {
    let startEndAlldayList = []
    for (let index = 0; index < arrList.length; index++) {
      let arr = dayList.filter(item => {
        return item.day === arrList[index].date
      })
      let date = new Date(arrList[index].date)
      let m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      let obj = {
        date: arrList[index].date,
        week: this.weeks[date.getDay()],
        m: m,
        status: 0
      }
      if (arr.length > 0) {
        obj.status = arr[0].status
      }
      startEndAlldayList.push(obj)
    }
    return startEndAlldayList
  }
}

const calculationTime = new CalculationTime()

export default calculationTime


// WEBPACK FOOTER //
// ./src/comm/utils/calculationTime.js